import React, {useEffect} from "react";
const Accounts = () => {
       useEffect(() => {
                const scriptUrls = [
                  "assets/js/jquery-3.7.1.min.js",
                  "assets/js/bootstrap.bundle.min.js",
                  "assets/plugins/theia-sticky-sidebar/ResizeSensor.js",
                  "assets/plugins/theia-sticky-sidebar/theia-sticky-sidebar.js",
                  "assets/plugins/select2/js/select2.min.js",
                  "assets/js/moment.min.js",
                  "assets/js/bootstrap-datetimepicker.min.js",
                  "assets/js/script.js"
                ];
            
                let isCancelled = false;
            
                const loadScriptsSequentially = async () => {
                  for (const url of scriptUrls) {
                    if (isCancelled) break;
            
                    await new Promise((resolve, reject) => {
                      const script = document.createElement('script');
                      script.src = url;
                      script.async = false;
                      script.onload = () => {
                        console.log(`Loaded: ${url}`);
                        resolve();
                      };
                      script.onerror = () => {
                        console.error(`Failed to load: ${url}`);
                        reject();
                      };
                      document.body.appendChild(script);
                    });
                  }
            
                  // Now init plugins after scripts are loaded
                  if (!isCancelled) {
                    // if (window.AOS) {
                    //   window.AOS.init();
                    // }
            
                    if (window.$ && typeof window.$.fn.datetimepicker === 'function') {
                      window.$('.datetimepicker').datetimepicker();
                    }
            
                    if (typeof window.initBackToTop === 'function') {
                      window.initBackToTop(); // assuming your backToTop script defines this
                    }
            
                    console.log('All scripts loaded and initialized.');
                  }
                };
            
                loadScriptsSequentially();
            
                return () => {
                  isCancelled = true;
                };
              }, []);
    return(
        <>
        <div class="col-lg-8 col-xl-9">
							<div class="accunts-sec">
								<div class="dashboard-header">
									<div class="header-back">									
										<h3>Wallet</h3>
									</div>
								</div>
								<div class="account-details-box">
									<div class="row">
										<div class="col-xxl-7 col-lg-7">
											<div class="account-payment-info">
												<div class="row">
													<div class="col-lg-6 col-md-6">
														<div class="payment-amount">
															<h6><i class="isa isax-wallet-25 text-warning"></i>Total Balance</h6>
															<span>$1200</span>
														</div>
													</div>
													<div class="col-lg-6 col-md-6">
														<div class="payment-amount">
															<h6><i class="isax isax-document5 text-success"></i>Total Transaction</h6>
															<span>$2300</span>
														</div>
													</div>
												</div>
												<div class="payment-request">
													<span>Last Payment request : 24 Mar 2023</span>
													<a href="#payment_request" class="btn btn-md btn-primary-gradient rounded-pill" data-bs-toggle="modal">Add Payment</a>
												</div>
											</div>
										</div>
										<div class="col-xxl-5 col-lg-5">
											<div class="bank-details-info">
												<h3>Bank Details</h3>
												<ul>
													<li>
														<h6>Bank Name</h6>
														<h5>Citi Bank Inc</h5>
													</li>
													<li>
														<h6>Account Number</h6>
														<h5>5396 5250 1908 XXXX</h5>
													</li>
													<li>
														<h6>Branch Name</h6>
														<h5>London</h5>
													</li>
													<li>
														<h6>Account Name</h6>
														<h5>Darren</h5>
													</li>
												</ul>
												<div class="edit-detail-link d-flex align-items-center justify-content-between w-100">
													<div>
														<a href="#edit_card" data-bs-toggle="modal">Edit Details</a>
														<a href="#add_card" data-bs-toggle="modal">Add Cards</a>
													</div>
													<a href="#other_accounts" data-bs-toggle="modal">Other Accounts</a>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-sm-12">
									<div class="account-detail-table">
										
										<div class="custom-new-table">
											<div class="table-responsive">
												<table class="table table-center mb-0">
													<thead>
														<tr>
															<th>ID</th>
															<th>Account No</th>
															<th>Reason</th>
															<th>Debited / Credited On</th>
															<th>Amount</th>
															<th>Status</th>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td>
																{/* <a> */} <button class="link-primary">#AC1234</button>
															</td>
															<td class="text-gray-9">5396 5250 1908 XXXX</td>
															<td>Appointment</td>
															<td>26 Mar 2024</td>
															<td>$300</td>
															<td>
																<span class="badge badge-success-transparent inline-flex align-items-center"><i class="fa-solid fa-circle me-1 fs-5"></i>Completed</span>
															</td>
														</tr>
														<tr>
															<td>
																{/* <a> */} <button class="link-primary">#AC3656</button>
															</td>
															<td class="text-gray-9">6372 4902 4902 XXXX</td>
															<td>Appointment</td>
															<td>28 Mar 2024</td>
															<td>$480</td>
															<td>
																<span class="badge badge-success-transparent inline-flex align-items-center"><i class="fa-solid fa-circle me-1 fs-5"></i>Completed</span>
															</td>
														</tr>
														<tr>
															<td>
																{/* <a> */} <button class="link-primary">#AC1246</button>
															</td>
															<td class="text-gray-9">4892 0204 4924 XXXX</td>
															<td>Appointment</td>
															<td>11 Apr 2024</td>
															<td>$250</td>
															<td>
																<span class="badge badge-success-transparent inline-flex align-items-center"><i class="fa-solid fa-circle me-1 fs-5"></i>Completed</span>
															</td>
														</tr>
														<tr>
															<td>
																{/* <a> */} <button class="link-primary">#AC6985</button>
															</td>
															<td class="text-gray-9">5730 4892 0492 XXXX</td>
															<td>Refund</td>
															<td>18 Apr 2024</td>
															<td>$220</td>
															<td>
																<span class="badge badge-warning-transparent inline-flex align-items-center"><i class="fa-solid fa-circle me-1 fs-5"></i>Pending</span>
															</td>
														</tr>
														<tr>
															<td>
																{/* <a> */} <button class="link-primary">#AC3659</button>
															</td>
															<td class="text-gray-9">7922 9024 5824 XXXX</td>
															<td>Appointment</td>
															<td>29 Apr 2024</td>
															<td>$350</td>
															<td>
																<span class="badge badge-success-transparent inline-flex align-items-center"><i class="fa-solid fa-circle me-1 fs-5"></i>Completed</span>
															</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>

									</div>
								</div>
							</div>
								
						</div>

  {/* Payment Moodal */}
  <div className="modal fade custom-modals" id="payment_request">
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Add Payment</h5>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i className="fa-solid fa-xmark" />
          </button>
        </div>
        <form>
          <div className="modal-body pb-0">
            <div className="mb-3">
              <label className="form-label">Enter Amount <span className="text-danger">*</span></label>
              <input type="text" className="form-control" />
            </div>	
            <div className="mb-3">
              <label className="form-label">Select Payment Gateway <span className="text-danger">*</span></label>
              <select className="select">
                <option>Select</option>
                <option>Card</option>
                <option>Paypal</option>
              </select>
            </div>			
          </div>
          <div className="modal-footer">					
            <div className="modal-btn text-end">
              <button className="btn btn-md btn-dark rounded-pill" data-bs-toggle="modal" data-bs-dismiss="modal">Cancel</button>
              <button type="submit" className="btn btn-md btn-primary-gradient rounded-pill">Add to Wallet</button>
            </div>
          </div>
        </form>		
      </div>
    </div>
  </div>
  {/* /Payment Moodal */}
  {/* Account Details Modal*/}
  <div className="modal fade custom-modals" id="add_card">
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Add Card</h5>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i className="fa-solid fa-xmark" />
          </button>
        </div>
        <form>
          <div className="modal-body pb-0">
            <div className="mb-3">
              <label className="form-label">Card Holder Name <span className="text-danger">*</span></label>
              <input type="text" className="form-control" />
            </div>	
            <div className="mb-3">
              <label className="form-label">Card Number <span className="text-danger">*</span></label>
              <input type="text" className="form-control" />
            </div>
            <div className="mb-3">
              <label className="form-label">Expire Date <span className="text-danger">*</span></label>
              <div className="form-icon">
                <input type="text" className="form-control datetimepicker" />
                <span className="icon"><i className="isax isax-calendar-1" /></span>
              </div>
            </div>
            <div className="mb-3">
              <label className="form-label">CVV <span className="text-danger">*</span></label>
              <input type="text" className="form-control" />
            </div>
            <div className="mb-3">
              <label className="form-label">Branch <span className="text-danger">*</span></label>
              <select className="select">
                <option>Select</option>
                <option>London</option>
                <option>Newyork</option>
              </select>
            </div>				
          </div>
          <div className="modal-footer">				
            <div className="modal-btn d-flex align-items-center justify-content-between flex-wrap gap-3 w-100">
              <div className="form-check d-flex">
                <input className="form-check-input" type="checkbox" id="mark" />
                <label className="form-check-label fs-14 ms-2" htmlFor="mark">
                  Mark as Default
                </label>
              </div>
              <div>
                <button className="btn btn-md btn-dark rounded-pill" data-bs-toggle="modal" data-bs-dismiss="modal">Cancel</button>
                <button type="submit" className="btn btn-md btn-primary-gradient rounded-pill">Add Card</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  {/* /Account Details Modal*/}
  {/* Account Details Modal*/}
  <div className="modal fade custom-modals" id="edit_card">
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Edit Card</h5>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i className="fa-solid fa-xmark" />
          </button>
        </div>
        <form>
          <div className="modal-body pb-0">
            <div className="mb-3">
              <label className="form-label">Card Holder Name <span className="text-danger">*</span></label>
              <input type="text" className="form-control" defaultValue="Darren" />
            </div>	
            <div className="mb-3">
              <label className="form-label">Card Number <span className="text-danger">*</span></label>
              <input type="text" className="form-control" defaultValue="5396 5250 1908 1647" />
            </div>
            <div className="mb-3">
              <label className="form-label">Expire Date <span className="text-danger">*</span></label>
              <div className="form-icon">
                <input type="text" className="form-control datetimepicker" defaultValue="15-04-2026" />
                <span className="icon"><i className="isax isax-calendar-1" /></span>
              </div>
            </div>
            <div className="mb-3">
              <label className="form-label">CVV <span className="text-danger">*</span></label>
              <input type="text" className="form-control" defaultValue={556} />
            </div>
            <div className="mb-3">
              <label className="form-label">Branch <span className="text-danger">*</span></label>
              <select className="select">
                <option>Select</option>
                <option selected>London</option>
                <option>Newyork</option>
              </select>
            </div>				
          </div>
          <div className="modal-footer">					
            <div className="modal-btn d-flex align-items-center justify-content-between flex-wrap gap-3 w-100">
              <div className="form-check d-flex">
                <input className="form-check-input" type="checkbox" id="mark1" defaultChecked />
                <label className="form-check-label fs-14 ms-2" htmlFor="mark1">
                  Mark as Default
                </label>
              </div>
              <div>
                <button className="btn btn-md btn-dark rounded-pill" data-bs-toggle="modal" data-bs-dismiss="modal">Cancel</button>
                <button type="submit" className="btn btn-md btn-primary-gradient rounded-pill">Save Changes</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  {/* /Account Details Modal*/}
  {/* Other Accounts Modal*/}
  <div className="modal fade custom-modals modal-lg" id="other_accounts">
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Other Accounts</h5>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i className="fa-solid fa-xmark" />
          </button>
        </div>
        <div className="modal-body">
          <div className="other-accounts-info">
            <ul>
              <li>
                <ul className="other-bank-info">
                  <li>
                    <h6>Name</h6>
                    <span>Citi Bank Inc</span>
                  </li>
                  <li>
                    <h6>Account No</h6>
                    <span>5396 5250 1908 XXXX</span>
                  </li>
                  <li>
                    <h6>Branch</h6>
                    <span>London</span>
                  </li>
                  <li>
                    <h6>Name on Bank Account</h6>
                    <span>Edalin Hendry</span>
                  </li>
                  <li>
                    <button>Current</button>
                  </li>
                </ul>
              </li>
              <li>
                <ul className="other-bank-info">
                  <li>
                    <h6>Name</h6>
                    <span>HDFC Bank Inc</span>
                  </li>
                  <li>
                    <h6>Account No</h6>
                    <span>7382 4924 4924 XXXX</span>
                  </li>
                  <li>
                    <h6>Branch</h6>
                    <span>New York</span>
                  </li>
                  <li>
                    <h6>Name on Bank Account</h6>
                    <span>Edalin Hendry</span>
                  </li>
                  <li>
                    <button>Change to default</button>
                  </li>
                </ul>
              </li>
              <li>
                <ul className="other-bank-info">
                  <li>
                    <h6>Name</h6>
                    <span>Union Bank Inc</span>
                  </li>
                  <li>
                    <h6>Account No</h6>
                    <span>8934 4902 9024 XXXX</span>
                  </li>
                  <li>
                    <h6>Branch</h6>
                    <span>Chicago</span>
                  </li>
                  <li>
                    <h6>Name on Bank Account</h6>
                    <span>Edalin Hendry</span>
                  </li>
                  <li>
                    <button>Change to default</button>
                  </li>
                </ul>
              </li>
              <li>
                <ul className="other-bank-info">
                  <li>
                    <h6>Name</h6>
                    <span>KVB Bank Inc</span>
                  </li>
                  <li>
                    <h6>Account No</h6>
                    <span>5892 4920 4829 XXXX</span>
                  </li>
                  <li>
                    <h6>Branch</h6>
                    <span>Austin</span>
                  </li>
                  <li>
                    <h6>Name on Bank Account</h6>
                    <span>Edalin Hendry</span>
                  </li>
                  <li>
                    <button>Change to default</button>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="modal-footer">					
          <div className="modal-btn text-end">
            <button type="submit" className="btn btn-md btn-primary-gradient rounded-pill" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* /Other Accounts Modal*/}
  {/* Request Completed Modal*/}
  <div className="modal fade custom-modal custom-modal-two" id="request_details_modal">
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Request Details <span className="badge badge-success-bg">Completed</span></h5>
          <button type="button" data-bs-dismiss="modal" aria-label="Close">
            <span><i className="fa-solid fa-x" /></span>
          </button>
        </div>
        <div className="modal-body">
          <div className="completed-request">
            <ul>
              <li>
                <h6>ID</h6>
                <span>#AC-1234</span>
              </li>
              <li>
                <h6>Requested on</h6>
                <span>24 Mar 2024</span>
              </li>
              <li>
                <h6>Credited Date</h6>
                <span>24 Mar 2024</span>
              </li>
              <li>
                <h6>Amount</h6>
                <span className="link-primary">$300</span>
              </li>
            </ul>
            <div className="bank-detail">
              <h4>Bank Details</h4>
              <div className="accont-information">
                <h6>Name</h6>
                <span>Citi Bank Inc</span>
              </div>
              <div className="accont-information">
                <h6>Account No</h6>
                <span>5396 5250 1908 XXXX</span>
              </div>
              <div className="accont-information">
                <h6>Branch</h6>
                <span>London</span>
              </div>
            </div>
            <div className="request-des">
              <h4>Reqeust Description</h4>
              <p>I recently completed a series of dental treatments with Dr.Edalin Hendry, 
                and I couldn't be more pleased with the results. From my very first appointment.
              </p>
            </div>
            <button className="btn btn-primary prime-btn w-100" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* /Request Completed Modal*/}
  {/* Request Cancel Modal*/}
  <div className="modal fade custom-modal custom-modal-two" id="request_cancel_modal">
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Request Details <span className="badge badge-danger-bg">Cancelled</span></h5>
          <button type="button" data-bs-dismiss="modal" aria-label="Close">
            <span><i className="fa-solid fa-x" /></span>
          </button>
        </div>
        <div className="modal-body">
          <div className="cancelled-request">
            <div className="canceled-user-info d-flex align-items-center">
              <div className="patinet-information">
                <a href="/">
                  <img src="assets/img/doctors-dashboard/profile-01.jpg" alt="User " />
                </a>
                <div className="patient-info">
                  <p>#Apt0001</p>
                  <h6><a href="/">Adrian</a></h6>
                </div>
              </div>
              <div className="email-info">
                <ul>
                  <li><i className="isax isax-sms5" /><a href="https://doccure.dreamstechnologies.com/cdn-cgi/l/email-protection" className="__cf_email__" data-cfemail="33525741525d73564b525e435f561d505c5e">[email&nbsp;protected]</a></li>
                  <li><i className="isax isax-call5" />+1 504 368 6874</li>
                </ul>
              </div>
            </div>
            <div className="cancellation-fees">
              <h6>Consultation Fees : $200</h6>
              <div className="cancellation-info">
                <div className="appointment-type">
                  <p className="md-text">Type of Appointment</p>
                  <p><i className="fa-solid fa-building text-green" />Direct Visit</p>
                </div>
                <div className="appointment-type">
                  <p className="md-text">Clinic Location</p>
                  <p>Adrian’s Dentistry</p>
                </div>
              </div>
            </div>
            <div className="cancel-reason">
              <h5>Reason</h5>
              <p>I have an urgent surgery, while our Appointment so i am rejecting appointment </p>
              <span className="text-danger">Cancelled By You on 23 Mar 2024</span>
            </div>
            <div className="refund-status">
              <span className="link-primary refund">Status :  Initiated</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* /Request Cancel Modal*/}
  {/* Refund Request Modal*/}
  <div className="modal fade info-modal" id="refund-request">
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-body">
          <div className="success-wrap text-center">
            <span className="icon-success"><i className="fa-solid fa-calendar-check" /></span>
            <h3>Refund initiated Successfully</h3>
            <p>Your Payment will be credited in your bank account in 3 working days</p>
            <button className="btn btn-primary prime-btn" data-bs-dismiss="modal">Okay</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* /Refund Request Modal*/}


                        </>
    );
}
export default Accounts;